import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const Date_Picker = ({ data, setData, format }) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const handleDateChange = (date) => {
    setData(new Date(date));
    // setPickerOpen(true);
  };
  //function for clicking "ok"
  const handleAccept = (date) => {
    setSelectedDate(date);
    setPickerOpen(false);
    if (date == null) {
      setData(null);
    } else {
      setData(new Date(date));
      // const date2 = selectedDate ? new Date(selectedDate) : null;
      // const date3 = date2
      //   ? date2.toLocaleDateString("en-US", {
      //     month: "2-digit",
      //     day: "2-digit",
      //     year: "numeric",
      //   })
      //   : "";
      // const date4 = date3.replace(/\//g, "-");
      // setData(date4);
    }
  };

  const handleOpen = () => {
    setPickerOpen(true);
  };

  const handleClose = () => {
    setPickerOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        closeOnSelect
        sx={{
          width: "100%",
          backgroundColor: "white",
          "& .MuiInputBase-root": {
            
            height: 33.5,
            paddingX: 0,
          },
          "& .MuiInputBase-input": {
            fontSize: 14,
            height: 0,
            paddingX: 1,
          },
          "& .MuiIconButton-root": {
            width: 24,
            paddingX: 0.01,
            marginRight: 1, //Set the color of the calendar icon button
          },
        }}
        value={data != null ? dayjs(data) : null}
        format={format}
        onChange={handleDateChange}
        //onAccept={handleAccept}
        onOpen={handleOpen}
        slotProps={{
          actionBar: {
            actions: ["clear"],
          },
        }}
        open={pickerOpen}
        onClose={handleClose}
        onInputChange={(event) => { }}
      />
    </LocalizationProvider>
  );
};

export default Date_Picker;
